import { useEffect } from "react";
const REFRESH_EVENT = "mypos:refresh";
export function triggerGlobalRefresh() {
    if (typeof window === "undefined")
        return;
    try {
        void window.till?.sync?.trigger?.();
    }
    catch {
        /* shim/IPC not present — fine */
    }
    window.dispatchEvent(new CustomEvent(REFRESH_EVENT));
}
export function useGlobalRefresh(handler) {
    useEffect(() => {
        const fn = () => handler();
        window.addEventListener(REFRESH_EVENT, fn);
        return () => window.removeEventListener(REFRESH_EVENT, fn);
    }, [handler]);
}
//# sourceMappingURL=refresh.js.map